import { useEffect } from "react";

const WIDGET_ID = "ux4g-accessibility-widget";
const WIDGET_SRC = "https://cdn.ux4g.gov.in/accessibility-v3.0/accessibility-widget.js";

/**
 * Loads the UX4G accessibility widget once.
 * Render it once near the root: <UX4GAccessibilityWidget /> inside App.tsx
 */
const UX4GAccessibilityWidget = () => {
    useEffect(() => {
        // Avoid loading twice (React StrictMode / re-mounts)
        if (document.getElementById(WIDGET_ID)) return;

        const script = document.createElement("script");
        script.id = WIDGET_ID;
        script.src = WIDGET_SRC;
        script.async = true;

        // Same as the Next.js onLoad in the email: the widget waits for
        // DOMContentLoaded, which has already fired in a SPA, so we fire it again.
        script.onload = () => {
            try {
                const evt = new Event("DOMContentLoaded", { bubbles: true, cancelable: false });
                document.dispatchEvent(evt);
            } catch (e) {
                // no-op if synthetic event fails
            }
        };

        document.body.appendChild(script);
    }, []);

    return null;
};

export default UX4GAccessibilityWidget;